import AE from '../../../assets/svg/icons/flags/AE.svg';
import AN from '../../../assets/svg/icons/flags/AN.svg';
import AU from '../../../assets/svg/icons/flags/AU.svg';
import BA from '../../../assets/svg/icons/flags/BA.svg';
import BD from '../../../assets/svg/icons/flags/BD.svg';
import BE from '../../../assets/svg/icons/flags/BE.svg';
import BR from '../../../assets/svg/icons/flags/BR.svg';
import BS from '../../../assets/svg/icons/flags/BS.svg';
import CA from '../../../assets/svg/icons/flags/CA.svg';
import CL from '../../../assets/svg/icons/flags/CL.svg';
import CN from '../../../assets/svg/icons/flags/CN.svg';
import CO from '../../../assets/svg/icons/flags/CO.svg';
import CR from '../../../assets/svg/icons/flags/CR.svg';
import DE from '../../../assets/svg/icons/flags/DE.svg';
import DO from '../../../assets/svg/icons/flags/DO.svg';
import EC from '../../../assets/svg/icons/flags/EC.svg';
import EG from '../../../assets/svg/icons/flags/EG.svg';
import ES from '../../../assets/svg/icons/flags/ES.svg';
import FR from '../../../assets/svg/icons/flags/FR.svg';
import GB from '../../../assets/svg/icons/flags/GB.svg';
import GT from '../../../assets/svg/icons/flags/GT.svg';
import HK from '../../../assets/svg/icons/flags/HK.svg';
import HN from '../../../assets/svg/icons/flags/HN.svg';
import ID from '../../../assets/svg/icons/flags/ID.svg';
import IE from '../../../assets/svg/icons/flags/IE.svg';
import IL from '../../../assets/svg/icons/flags/IL.svg';
import IN from '../../../assets/svg/icons/flags/IN.svg';
import IT from '../../../assets/svg/icons/flags/IT.svg';
import JP from '../../../assets/svg/icons/flags/JP.svg';
import KH from '../../../assets/svg/icons/flags/KH.svg';
import KR from '../../../assets/svg/icons/flags/KR.svg';
import LA from '../../../assets/svg/icons/flags/LA.svg';
import LK from '../../../assets/svg/icons/flags/LK.svg';
import MX from '../../../assets/svg/icons/flags/MX.svg';
import MY from '../../../assets/svg/icons/flags/MY.svg';
import NL from '../../../assets/svg/icons/flags/NL.svg';
import NO from '../../../assets/svg/icons/flags/NO.svg';
import NZ from '../../../assets/svg/icons/flags/NZ.svg';
import PA from '../../../assets/svg/icons/flags/PA.svg';
import PE from '../../../assets/svg/icons/flags/PE.svg';
import PH from '../../../assets/svg/icons/flags/PH.svg';
import PK from '../../../assets/svg/icons/flags/PK.svg';
import PL from '../../../assets/svg/icons/flags/PL.svg';
import PT from '../../../assets/svg/icons/flags/PT.svg';
import RO from '../../../assets/svg/icons/flags/RO.svg';
import SA from '../../../assets/svg/icons/flags/SA.svg';
import SE from '../../../assets/svg/icons/flags/SE.svg';
import SG from '../../../assets/svg/icons/flags/SG.svg';
import SV from '../../../assets/svg/icons/flags/SV.svg';
import TH from '../../../assets/svg/icons/flags/TH.svg';
import TR from '../../../assets/svg/icons/flags/TR.svg';
import TW from '../../../assets/svg/icons/flags/TW.svg';
import UK from '../../../assets/svg/icons/flags/UK.svg';
import UM from '../../../assets/svg/icons/flags/UM.svg';
import US from '../../../assets/svg/icons/flags/US.svg';
import VN from '../../../assets/svg/icons/flags/VN.svg';
import ZA from '../../../assets/svg/icons/flags/ZA.svg';
import PLACEHOLDER from '../../../assets/svg/icons/flags/PLACEHOLDER.svg';

import AI_ASSIST from '../../../assets/svg/icons/ai-assist.svg';
import ALERT_CIRCLE from '../../../assets/svg/icons/alert-circle.svg';
import AMAZON_CIRCLE from '../../../assets/svg/icons/amazon-circle.svg';
import ANNOTATION_ALERT from '../../../assets/svg/icons/annotation-alert.svg';
import ANNOTATION_CHECK from '../../../assets/svg/icons/annotation-check.svg';
import API_CLOUD from '../../../assets/svg/icons/api-cloud.svg';
import ARROW_DOWN from '../../../assets/svg/icons/arrow-down.svg';
import ARROW_LEFT from '../../../assets/svg/icons/arrow-left.svg';
import ARROW_RIGHT from '../../../assets/svg/icons/arrow-right.svg';
import ARROW_UP from '../../../assets/svg/icons/arrow-up.svg';
import BELL_OFF from '../../../assets/svg/icons/bell-off.svg';
import BELL from '../../../assets/svg/icons/bell.svg';
import BELL_FILLED from '../../../assets/svg/icons/bell-filled.svg';
import BOOKMARK_FILLED from '../../../assets/svg/icons/bookmark-filled.svg';
import BOOKMARK from '../../../assets/svg/icons/bookmark.svg';
import CALENDAR from '../../../assets/svg/icons/calendar.svg';
import CARET_DOWN from '../../../assets/svg/icons/caret-down.svg';
import CARET_LEFT from '../../../assets/svg/icons/caret-left.svg';
import CARET_RIGHT from '../../../assets/svg/icons/caret-right.svg';
import CARET_UP from '../../../assets/svg/icons/caret-up.svg';
import CHART_AREA from '../../../assets/svg/icons/chart-area.svg';
import CHART_AREA_FULL from '../../../assets/svg/icons/chart-area-full.svg';
import CHART_LINE_ARROW from '../../../assets/svg/icons/chart-line-arrow.svg';
import CHART_LINE_SIMPLE from '../../../assets/svg/icons/chart-line-simple.svg';
import CHART_TREEMAP from '../../../assets/svg/icons/chart-treemap.svg';
import CHECK_CIRCLE from '../../../assets/svg/icons/check-circle.svg';
import CHECK from '../../../assets/svg/icons/check.svg';
import CHEVRON_DOWN from '../../../assets/svg/icons/chevron-down.svg';
import CHEVRON_LEFT from '../../../assets/svg/icons/chevron-left.svg';
import CHEVRON_RIGHT from '../../../assets/svg/icons/chevron-right.svg';
import CHEVRON_UP from '../../../assets/svg/icons/chevron-up.svg';
import COPY from '../../../assets/svg/icons/copy.svg';
import CORNER_DOWN_RIGHT from '../../../assets/svg/icons/corner-down-right.svg';
import CREDIT_CARD from '../../../assets/svg/icons/credit-card.svg';
import DOCK_MODE from '../../../assets/svg/icons/dock-mode.svg';
import DOWNLOAD from '../../../assets/svg/icons/download.svg';
import DRAG from '../../../assets/svg/icons/drag.svg';
import EYE_OFF from '../../../assets/svg/icons/eye-off.svg';
import EYE from '../../../assets/svg/icons/eye.svg';
import FILE from '../../../assets/svg/icons/file.svg';
import FILTER_FUNNEL from '../../../assets/svg/icons/filter-funnel.svg';
import FOLDER_ADD from '../../../assets/svg/icons/folder-add.svg';
import FOLDER_DOWNLOAD from '../../../assets/svg/icons/folder-download.svg';
import FOLDER_MOVE from '../../../assets/svg/icons/folder-move.svg';
import GOOGLE_CHROME from '../../../assets/svg/icons/google-chrome.svg';
import HEART from '../../../assets/svg/icons/heart.svg';
import HEART_FILLED from '../../../assets/svg/icons/heart-filled.svg';
import HELP_CIRCLE from '../../../assets/svg/icons/help-circle.svg';
import IMAGE from '../../../assets/svg/icons/image.svg';
import KEY from '../../../assets/svg/icons/key.svg';
import LAYERS from '../../../assets/svg/icons/layers.svg';
import LIGHTBULB from '../../../assets/svg/icons/lightbulb.svg';
import LINK_EXTERNAL from '../../../assets/svg/icons/link-external.svg';
import LOCK from '../../../assets/svg/icons/lock.svg';
import LOG_OUT from '../../../assets/svg/icons/log-out.svg';
import LOWERCASE from '../../../assets/svg/icons/lowercase.svg';
import MAIL_CHECK from '../../../assets/svg/icons/mail-check.svg';
import MAIL from '../../../assets/svg/icons/mail.svg';
import MINUS from '../../../assets/svg/icons/minus.svg';
import MINUS_SQUARE from '../../../assets/svg/icons/minus-square.svg';
import MODAL_MODE from '../../../assets/svg/icons/modal-mode.svg';
import MORE from '../../../assets/svg/icons/more.svg';
import NAV_ACADEMY from '../../../assets/svg/icons/nav-academy.svg';
import NAV_ADMIN_PANEL from '../../../assets/svg/icons/nav-admin-panel.svg';
import NAV_ANALYTICS from '../../../assets/svg/icons/nav-analytics.svg';
import NAV_CI from '../../../assets/svg/icons/nav-ci.svg';
import NAV_DEVELOPER from '../../../assets/svg/icons/nav-developer.svg';
import NAV_EXTENSION from '../../../assets/svg/icons/nav-extension.svg';
import NAV_HOME from '../../../assets/svg/icons/nav-home.svg';
import NAV_KEYWORDS from '../../../assets/svg/icons/nav-keywords.svg';
import NAV_MANAGE_PROD from '../../../assets/svg/icons/nav-manage-prod.svg';
import NAV_MARKET_INSIGHT from '../../../assets/svg/icons/nav-market-insight.svg';
import NAV_PROD_INSIGHTS from '../../../assets/svg/icons/nav-prod-insights.svg';
import NAV_PROD_RESEARCH from '../../../assets/svg/icons/nav-prod-research.svg';
import NAV_REIMBURSEMENT from '../../../assets/svg/icons/nav-reimbursement.svg';
import NAV_REVIEW_AUTOMATION from '../../../assets/svg/icons/nav-review-automation.svg';
import NAV_SHARE_VOICE from '../../../assets/svg/icons/nav-share-voice.svg';
import NAV_SUPPLIERS from '../../../assets/svg/icons/nav-suppliers.svg';
import PENCIL from '../../../assets/svg/icons/pencil.svg';
import PIN from '../../../assets/svg/icons/pin.svg';
import PIN_REMOVE from '../../../assets/svg/icons/pin-remove.svg';
import PLAY_CIRCLE from '../../../assets/svg/icons/play-circle.svg';
import PLUS_CIRCLE from '../../../assets/svg/icons/plus-circle.svg';
import PLUS_SQUARE from '../../../assets/svg/icons/plus-square.svg';
import PLUS from '../../../assets/svg/icons/plus.svg';
import POWER from '../../../assets/svg/icons/power.svg';
import REDO from '../../../assets/svg/icons/redo.svg';
import REFUND from '../../../assets/svg/icons/refund.svg';
import RECEIPT from '../../../assets/svg/icons/receipt.svg';
import REFRESH from '../../../assets/svg/icons/refresh.svg';
import ROCKET from '../../../assets/svg/icons/rocket.svg';
import RULER from '../../../assets/svg/icons/ruler.svg';
import SCALES from '../../../assets/svg/icons/scales.svg';
import SEARCH from '../../../assets/svg/icons/search.svg';
import SEND from '../../../assets/svg/icons/send.svg';
import SETTINGS from '../../../assets/svg/icons/settings.svg';
import SETTINGS_COG from '../../../assets/svg/icons/cog.svg';
import SHARE from '../../../assets/svg/icons/share.svg';
import SHOPPING_BAG from '../../../assets/svg/icons/shopping-bag.svg';
import STAR from '../../../assets/svg/icons/star.svg';
import STAR_EMPTY from '../../../assets/svg/icons/star-empty.svg';
import STAR_FULL from '../../../assets/svg/icons/star-full.svg';
import STAR_HALF from '../../../assets/svg/icons/star-half.svg';
import THUMBS_DOWN from '../../../assets/svg/icons/thumbs-down.svg';
import THUMBS_UP from '../../../assets/svg/icons/thumbs-up.svg';
import TITLECASE from '../../../assets/svg/icons/titlecase.svg';
import TOGGLE_ON from '../../../assets/svg/icons/toggle-on.svg';
import TOOLTIP_INFO from '../../../assets/svg/icons/tooltip-info.svg';
import TOOLTIP_QUESTION from '../../../assets/svg/icons/tooltip-question.svg';
import TOOLTIP_WARNING from '../../../assets/svg/icons/tooltip-warning.svg';
import TRANSLATE from '../../../assets/svg/icons/translate.svg';
import TRASH from '../../../assets/svg/icons/trash.svg';
import TRUCK from '../../../assets/svg/icons/truck.svg';
import UNDO from '../../../assets/svg/icons/undo.svg';
import UPLOAD from '../../../assets/svg/icons/upload.svg';
import UPPERCASE from '../../../assets/svg/icons/uppercase.svg';
import USER from '../../../assets/svg/icons/user.svg';
import USERS from '../../../assets/svg/icons/users.svg';
import VIDEO_RECORDER from '../../../assets/svg/icons/video-recorder.svg';
import WAREHOUSE_CHECK from '../../../assets/svg/icons/warehouse-check.svg';
import X_CIRCLE from '../../../assets/svg/icons/x-circle.svg';
import X_CLOSE from '../../../assets/svg/icons/x-close.svg';
import X_CLOSE_ROUND from '../../../assets/svg/icons/x-close-round.svg';

const FlagList = {
  AE,
  AN,
  AU,
  BA,
  BD,
  BE,
  BR,
  BS,
  CA,
  CL,
  CN,
  CO,
  CR,
  DE,
  DO,
  EC,
  EG,
  ES,
  FR,
  GB,
  GT,
  HK,
  HN,
  ID,
  IE,
  IL,
  IN,
  IT,
  JP,
  KH,
  KR,
  LA,
  LK,
  MX,
  MY,
  NL,
  NO,
  NZ,
  PA,
  PE,
  PH,
  PK,
  PL,
  PT,
  RO,
  SA,
  SE,
  SG,
  SV,
  TH,
  TR,
  TW,
  UK,
  UM,
  US,
  VN,
  ZA,
};

export const IconList = {
  /** Sort alphabetically */
  AI_ASSIST,
  ALERT_CIRCLE,
  AMAZON_CIRCLE,
  ANNOTATION_ALERT,
  ANNOTATION_CHECK,
  API_CLOUD,
  ARROW_DOWN,
  ARROW_LEFT,
  ARROW_RIGHT,
  ARROW_UP,
  BELL,
  BELL_FILLED,
  BELL_OFF,
  BOOKMARK,
  BOOKMARK_FILLED,
  CARET_DOWN,
  CARET_LEFT,
  CARET_RIGHT,
  CARET_UP,
  CALENDAR,
  CHART_AREA,
  CHART_AREA_FULL,
  CHART_LINE_ARROW,
  CHART_LINE_SIMPLE,
  CHART_TREEMAP,
  CHECK,
  CHECK_CIRCLE,
  CHEVRON_DOWN,
  CHEVRON_LEFT,
  CHEVRON_RIGHT,
  CHEVRON_UP,
  COPY,
  CORNER_DOWN_RIGHT,
  CREDIT_CARD,
  DOCK_MODE,
  DOWNLOAD,
  DRAG,
  EYE,
  EYE_OFF,
  FILE,
  FILTER_FUNNEL,
  FOLDER_ADD,
  FOLDER_DOWNLOAD,
  FOLDER_MOVE,
  GOOGLE_CHROME,
  HEART,
  HEART_FILLED,
  HELP_CIRCLE,
  IMAGE,
  KEY,
  LAYERS,
  LIGHTBULB,
  LINK_EXTERNAL,
  LOCK,
  LOG_OUT,
  LOWERCASE,
  MAIL_CHECK,
  MAIL,
  MINUS,
  MINUS_SQUARE,
  MODAL_MODE,
  MORE,
  NAV_ACADEMY,
  NAV_ADMIN_PANEL,
  NAV_ANALYTICS,
  NAV_CI,
  NAV_DEVELOPER,
  NAV_EXTENSION,
  NAV_HOME,
  NAV_KEYWORDS,
  NAV_MANAGE_PROD,
  NAV_MARKET_INSIGHT,
  NAV_PROD_INSIGHTS,
  NAV_PROD_RESEARCH,
  NAV_REIMBURSEMENT,
  NAV_REVIEW_AUTOMATION,
  NAV_SHARE_VOICE,
  NAV_SUPPLIERS,
  PENCIL,
  PIN,
  PIN_REMOVE,
  PLAY_CIRCLE,
  PLUS_CIRCLE,
  PLUS_SQUARE,
  PLUS,
  POWER,
  RECEIPT,
  REDO,
  REFRESH,
  REFUND,
  ROCKET,
  RULER,
  SCALES,
  SEARCH,
  SEND,
  SETTINGS,
  SETTINGS_COG,
  SHARE,
  SHOPPING_BAG,
  STAR,
  STAR_EMPTY,
  STAR_FULL,
  STAR_HALF,
  THUMBS_DOWN,
  THUMBS_UP,
  TITLECASE,
  TOGGLE_ON,
  TOOLTIP_INFO,
  TOOLTIP_QUESTION,
  TOOLTIP_WARNING,
  TRANSLATE,
  TRASH,
  TRUCK,
  UNDO,
  UPLOAD,
  UPPERCASE,
  USER,
  USERS,
  VIDEO_RECORDER,
  WAREHOUSE_CHECK,
  X_CIRCLE,
  X_CLOSE,
  X_CLOSE_ROUND,
  /** Ignore alphabetical sort */
  PLACEHOLDER,
  ...FlagList,
};

// Kept this here to avoid export FlagList and IconList to outside. The only accessible types
// are the ones below
export type FlagListType = keyof typeof FlagList;
export type IconListType = keyof typeof IconList;
